import React from "react";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ToastContainerWithTheme() {
  const color1 = useSelector((state) => state.teamState?.config?.color1);
  const progressColor = color1 || "#6366f1";

  return (
    <>
      <style>{`.Toastify__progress-bar { background: ${progressColor} !important; }`}</style>
      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
}
